import script from "./403.vue?vue&type=script&setup=true&lang=ts"
export * from "./403.vue?vue&type=script&setup=true&lang=ts"

import "./403.vue?vue&type=style&index=0&id=6b03d064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b03d064"]])

export default __exports__